// Cliente HTTP tipado para la API. Envia cookies (sesion) en cada request.

export class ApiError extends Error {
  status: number;
  constructor(status: number, mensaje: string) {
    super(mensaje);
    this.status = status;
  }
}

async function pedir<T>(metodo: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method: metodo,
    headers: body ? { "content-type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: "same-origin",
  });
  let data: unknown = null;
  const texto = await res.text();
  if (texto) {
    try {
      data = JSON.parse(texto);
    } catch {
      data = texto;
    }
  }
  if (!res.ok) {
    // Sesion invalidada (ej. se inicio sesion con este usuario en otro
    // dispositivo): volver al login. Se excluyen /api/login (clave incorrecta)
    // y /api/sesion (arranque sin sesion), que ya maneja el flujo de login.
    if (res.status === 401 && path !== "/api/login" && path !== "/api/sesion") {
      sessionStorage.setItem("sesionCerrada", "1");
      location.reload();
    }
    const msg =
      data && typeof data === "object" && "error" in data
        ? String((data as { error: unknown }).error)
        : `Error ${res.status}`;
    throw new ApiError(res.status, msg);
  }
  return data as T;
}

export const api = {
  get: <T>(path: string) => pedir<T>("GET", path),
  post: <T>(path: string, body?: unknown) => pedir<T>("POST", path, body),
  put: <T>(path: string, body?: unknown) => pedir<T>("PUT", path, body),
  del: <T>(path: string) => pedir<T>("DELETE", path),
};
